module.exports = __webpack_public_path__ + "img/service1_active.ac7e0458.png";